import appClient from '../../common/services/AppClient';
import { ExecuteMongoConsoleRequest, MongoConsoleQueryResult } from '../types';
import { endpoints } from '../../../config';

export default class MongoConsoleService {
    async getDatabases() {
        const url = `${endpoints.manageUrl}MongoConsole/databases`;
        const resp = await appClient.get<string[]>(url);
        return resp.unwrapOr([]);
    }

    async getCollections(database: string) {
        const url = `${endpoints.manageUrl}MongoConsole/databases/${encodeURIComponent(database)}/collections`;
        const resp = await appClient.get<string[]>(url);
        return resp.unwrapOr([]);
    }

    async executeQuery(data: ExecuteMongoConsoleRequest) {
        const url = `${endpoints.manageUrl}MongoConsole/execute`;
        return appClient.post<MongoConsoleQueryResult>(url, data);
    }
}
